import type { Shop } from "../lib/shopify";

import { fetchSecret } from "../lib/secrets";

export const shops: Shop[] = [
  {
    handle: "production",
    shopId: 32268419208,
    shopifyDomain: "bared-footwear-au.myshopify.com",
    checkoutDomain: "checkout.baredfootwear.com",
    storefrontId: "36092",
    publicStorefrontToken: "9a0e203b14e7c2928886602a003d0db2",
    privateStorefrontToken: () =>
      fetchSecret("SHOPIFY_STOREFRONT_PRIVATE_TOKEN_PRODUCTION"),
    adminAccessToken: () => fetchSecret("SHOPIFY_ADMIN_TOKEN_PRODUCTION"),
    customerAccountClientId: "shp_e55d0356-bb18-473d-89db-552e41657ed2",
    customerAccountClientSecret: () =>
      fetchSecret("SHOPIFY_CUSTOMER_ACCOUNT_CLIENT_SECRET_PRODUCTION"),
  },
  {
    handle: "staging",
    shopId: 32260685962,
    shopifyDomain: "bared-footwear-au-stage.myshopify.com",
    checkoutDomain: "bared-footwear-au-stage.myshopify.com",
    storefrontId: "36318",
    publicStorefrontToken: "881c82b6d2d31972c6e1bcafacb21983",
    privateStorefrontToken: () =>
      fetchSecret("SHOPIFY_STOREFRONT_PRIVATE_TOKEN_STAGING"),
    adminAccessToken: () => fetchSecret("SHOPIFY_ADMIN_TOKEN_STAGING"),
    customerAccountClientId: "shp_7f3e06cb-dae1-418c-bfdb-22963e09d790",
    customerAccountClientSecret: () =>
      fetchSecret("SHOPIFY_CUSTOMER_ACCOUNT_CLIENT_SECRET_STAGING"),
  },
];

export const adminApiVersion = "2025-01";

export const storefrontApiVersion = "2025-01";
